import Vue from 'vue'
const loading = Vue.extend(require('./loading.vue').default);

export default {
    install: function () {
        let instance = new loading({
            methods: {
                showbg(msg, callBack) {
                    this.show = true;
                 
                    document.body.appendChild(this.$el);
                },
                showNormal(msg, callBack) {
                    this.show = true;
                    document.body.appendChild(this.$el);
                },
                close() {
                    this.show = false;
                    if (document.body.getElementsByClassName('.loading')[0]) {
                        document.body.removeChild(this.$el);
                    }
                }
            }
        })
        instance.$mount();
        Vue.prototype.$loading = instance;


    }
};


// WEBPACK FOOTER //
// ./src/components/basic/view/loading/index.js